import script from "./HospitalEventComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalEventComponent.vue?vue&type=script&setup=true&lang=js"

import "./HospitalEventComponent.vue?vue&type=style&index=0&id=46b74ea5&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b74ea5"]])

export default __exports__